import { createJSONRequest } from './create-request'

export const fetchTransitionPulseMonths = () => createJSONRequest({
  url: '/api/transition-reports',
  method: 'GET',
})

export const fetchTransitionPulse = (id: number) => createJSONRequest({
  url: `/api/transition-reports/${id}`,
  method: 'GET',
})

export const fetchTransitionPulseSharedUsers = (id: number) => createJSONRequest({
  url: `/api/transition-reports/${id}/shared-users`,
  method: 'GET',
})

export const shareTransitionPulseWithUser = (id: number, userId: number) => createJSONRequest({
  url: `/api/transition-reports/${id}/shared-users`,
  method: 'POST',
  data: { user_id: userId },
})

export const unshareTransitionPulseWithUser = (id: number, userId: number) => createJSONRequest({
  url: `/api/transition-reports/${id}/shared-users/${userId}`,
  method: 'DELETE',
})

export const searchTransitionPulseShareableUsers = (id: number, query: string) => createJSONRequest({
  url: `/api/transition-reports/${id}/shared-users/search?query=${encodeURIComponent(query)}`,
  method: 'GET',
})
